/**
 * http://usejsdoc.org/
 */
import { create } from 'apisauce';

let api;
const func = {};
func.setApi = () => {
	if (window.ENV) {
		api = create({
			baseURL: window.ENV?.processorInfo.apiUrl
		});
	}
}
// define the api

const _formPostBody = (amount, orderId) => {
	var data = {
		"type": "sale",
		"amount": amount,
		"currency": "USD",
		"description": "test transaction",
		"order_id": orderId,
		"po_number": "somePONumber",
		"ip_address": "4.2.2.2",
		"email_receipt": false,
		"email_address": "user@home.com",
		"create_vault_record": true,
		"payment_method": {
			"terminal": {
				"id": window.ENV?.processorInfo.terminalId,
				"print_receipt": "both",
				"signature_required": false
			}
		}
	};
	return data;
}

func.searchTransaction = (searchBody) => {
	return api.post('/transaction/search', searchBody);
}

func.postTransaction = (amount, orderId) => {
	// console.log(api.getBaseURL());
	// console.log('in terminal authorize and capture');
	var postBody = _formPostBody(Math.round(amount), orderId);
	//console.log(postBody);
	return api.post('/transaction', postBody);
}

func.voidTransaction = (transactionId) => {
	// console.log(postBody);
	return api.post('/transaction/' + transactionId + '/void');
}

export default func;
